<div class="btn-group w-100" role="group">
  <button
    type="button"
    class="btn font-weight-bold"
    *ngFor="let item of items"
    [ngClass]="getBtnClass(item)"
    [innerText]="item[bindName] || null"
    [disabled]="disabled"
    (click)="select(item[bindValue] || null)"
  ></button>
</div>

